module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hJ8Pru/tc-custom/9781398439993.jpg?1705687883256",
      "alt": "This image is the cover for the book The A-Z of What You Can Be When You Grow Up"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The A-Z of What You Can Be When You Grow Up\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("As children love to learn through appealing pictures, they also need to explore the whole world of possibilities around them with high hopes. The A-Z of What You Can Be When You Grow Up introduces a range of unique and traditional professions that are achievable and possible for any child. As they grow and learn their alphabet, they can visualize what each job entails.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dr Henry C. Uzokwe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dr Henry C. Uzokwe is a consumer lawyer turned children’s author, with passion to change people’s lives for the better. While raising his children in Britain, he saw the need to help responsible parents to raise educated and confident children. He has given seminars and radio talks in many countries around the world. His blog, short videos and self-help books have helped many parents in raising responsible young adults.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0